import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Box,
    Typography,
    Button
} from '@mui/material';

const Unauthorized = () => {
    const navigate = useNavigate();

    return (
        <Container component="main" maxWidth="sm">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center'
                }}
            >
                <Typography component="h1" variant="h4" color="error" gutterBottom>
                    Access Denied
                </Typography>
                <Typography variant="body1" paragraph>
                    You don't have permission to access this page.
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate(-1)}
                    sx={{ mt: 2 }}
                >
                    Go Back
                </Button>
            </Box>
        </Container>
    );
};

export default Unauthorized; 